<template>
  <el-dialog
    :title="type=='refund' ? 'Refund' : 'Please note'"
    :visible.sync="isOpen"
    width="7rem"
    append-to-body
    :close-on-click-modal="false"
    destroy-on-close
    @close="close"
  >
    <div>
      <div v-if="type=='notReceived'" class="notReceived flexStart">
        <i class="el-icon-warning"/>
        <span>After confirming that the test token has not been received, the user account will fail to bind!</span>
      </div>
      <el-form
        v-if="type=='refund'"
        class="page-form point-form"
        ref="assetForm"
        :model="pageData"
        label-position="top"
      >
        <el-row :gutter="40">
          <el-col :span="24">
            <el-form-item prop="Account" label="treasurenet Account">
              {{ $store.getters.metaMaskObj.account }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              prop="amount"
              label="Refund ETH/BTC"
            >
              <span class="num">{{minAmount}}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer page-btns">
      <el-button @click="close">Cancel</el-button>
      <loading-btn type="primary" :label="submitText" @clickHandle="approval" />
    </span>

  </el-dialog>
</template>

<script>
import  { toBigItem, toBigNum } from "@/utils/bigNumberTran.js"
import { approvalProducerInfo } from "@/api/manager.js";

const minAmount = "0.00001";

export default {
  components:{},
  data() {
    return {
      isOpen: false,
      minAmount:"0.00001",
      pageData: {
        type:undefined,
        account:undefined
      },
      type:"",
      digitalType:undefined,
      submitText:"Submit"
    };
  },
  computed: {},
  methods: {
    open({digitalType, row, type } = {}) {
      this.type = type;
      this.digitalType = digitalType;
      this.isOpen = true;
      this.submitText = "Submit";
      this.pageData = row;
    },
    close() {
      this.isOpen = false;
      this.submitText = "Submit";
      this.pageData = {
        amount: minAmount,
        type:undefined,
        account:undefined
      };
    },
    async approval(btn){
      try{
        this.btn = btn;

        if(this.type=='refund'){
          const digitalType = this.digitalType == "btc" ? "BTC" : "ETH";
          const digitalAccount = this.digitalType == "btc" ? this.pageData.btcAccount : this.pageData.ethAccount;
          this.submitContract(digitalType, this.pageData.account, digitalAccount).then(res => {
            this.TransferAccount().then(trRes => {
              this.submitApprove();
            }).catch(e => {
              this.submitApprove();
            })
          })
          .catch(e => {
            this.btn && this.btn.closeLoad();
            this.$message.error("operation failed");
          })
        }else{
          this.submitApprove();
        }
      }catch(e){
        console.log(e);
        this.$message.error("operation failed");
      }
    },
    submitApprove(){
      const param = {
        userID: this.pageData.userID,
        type:this.digitalType,
        status: this.type=='refund' ? 2 : 3
      }
      approvalProducerInfo(param).then(res => {
        this.btn && this.btn.closeLoad();
        this.close();
        this.$emit("success",this.type)
      }).catch(e => {
        console.log(e);
        this.btn && this.btn.closeLoad();
        this.$message.error("operation failed");
      })
    },
    submitContract(type, account, typeAccount){
      return new Promise((resolve, reject) => {
        try{
          console.log(type,account, typeAccount)
          this.contractGovernance = this.$store.getters.contractMap["contractGovernance"].contract;
          this.contractGovernanceAddress = this.$store.getters.contractMap["contractGovernance"].address;
          const tx_builder = this.contractGovernance.methods["setMineAddress"](
            type, account , typeAccount
          );
          const encoded_tx = tx_builder.encodeABI();
          web3.eth
            .sendTransaction({
              gas: this.$store.getters.gas,
              from: this.$store.getters.metaMaskObj.account,
              to: this.contractGovernanceAddress,
              value: 0,
              data: encoded_tx
            })
            .then(res => {
              resolve();
            })
            .catch(error => {
              console.error(error);
              reject(error);
            });
        }catch(e){
          console.error(e);
          this.$message.error("operation failed");
        }
      })
    },
    TransferAccount(){
      try{
        return new Promise((resolve, reject) => {
          this.submitText = "Transferring...";
          web3.eth
          .sendTransaction({
            gas: this.$store.getters.gas,
            from: this.$store.getters.metaMaskObj.FoundationManager,
            to: this.pageData.account,
            value: toBigNum("0.00001"),
          })
          .then(res => {
            this.submitText = "Submit...";
            resolve();
          })
          .catch(error => {
            this.submitText = "Submit...";
            this.$message.warning("Transfer failed");
            reject(error)
          });
        })

      }catch(e){
        console.log(e)
      }

    },
    goback(){
      this.$router.push("/authentication/approve");
    }
  },
  created() {}
};
</script>
<style scoped lang="scss">
.desc{
  font-size: 0.16rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.5);
  line-height: 0.24rem;
  margin-top:0.16rem;
}
.num{
  font-size: 0.28rem;
  font-weight: 500;
  color: #1F1F1F;
}
.notReceived{
  font-size: 0.22rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  line-height: 0.32rem;
  i{
    font-size: 0.24rem;
    color:#FAAD14;
    margin-right: 0.12rem;
  }
}
</style>
